module.exports = __webpack_public_path__ + "img/KOBhappylyBanner1.570dcc5.jpg";